import type { ThemeColors } from '../../../tokens/colors/types';

export default (
  baseColors: ThemeColors,
  brandSecondary?: string
): Record<string, unknown> => ({
  brandPrimary: {
    ...[
      baseColors.primary['20'],
      baseColors.primary['50'],
      baseColors.primary['70'],
    ],
    ...baseColors.primary,
  },
  brandSecondary,
  brandSupport: {
    lightest: baseColors.primary['20'],
    light: baseColors.primary['30'],
    default: baseColors.primary['50'],
    dark: baseColors.primary['70'],
    darkest: baseColors.primary['90'],
  },
  shadesPrimary: {
    ultraLight: baseColors.primary['10'],
    lightest: baseColors.primary['20'],
    light: baseColors.primary['30'],
    default: baseColors.primary['50'],
    dark: baseColors.primary['70'],
    darkest: baseColors.primary['90'],
  },
  shadesSecondary: {
    lightest: baseColors.secondary['20'],
    light: baseColors.secondary['30'],
    default: baseColors.secondary['50'],
    dark: baseColors.secondary['70'],
    darkest: baseColors.secondary['90'],
  },
  neutrals: {
    ...[
      baseColors.neutral['100'],
      baseColors.neutral['90'],
      baseColors.neutral['80'],
      baseColors.neutral['70'],
      baseColors.neutral['60'],
      baseColors.neutral['50'],
      baseColors.neutral['40'],
      baseColors.neutral['30'],
      baseColors.neutral['10'],
    ],
    light: baseColors.neutral['30'],
    default: baseColors.neutral['80'],
  },
  positive: {
    lightest: baseColors.green['20'],
    light: baseColors.green['30'],
    default: baseColors.green['50'],
    dark: baseColors.green['70'],
    darkest: baseColors.green['90'],
  },
  informative: {
    lightest: baseColors.blue['20'],
    light: baseColors.blue['30'],
    default: baseColors.blue['50'],
    dark: baseColors.blue['70'],
    darkest: baseColors.blue['90'],
  },
  warning: {
    lightest: baseColors.orange['20'],
    light: baseColors.orange['30'],
    default: baseColors.orange['50'],
    dark: baseColors.orange['70'],
    darkest: baseColors.orange['90'],
  },
  negative: {
    lightest: baseColors.red['20'],
    light: baseColors.red['30'],
    default: baseColors.red['50'],
    dark: baseColors.red['70'],
    darkest: baseColors.red['90'],
  },
  critical: {
    lightest: baseColors.red['20'],
    light: baseColors.red['30'],
    default: baseColors.red['50'],
    dark: baseColors.red['70'],
    darkest: baseColors.red['90'],
  },
});
